// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
import { RoleType } from './custom-types.js';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    id: z.string().min(1).max(21),
    name: z.string().min(1).max(128),
    description: z.string().max(256).nullable().optional(),
    type: z.nativeEnum(RoleType).optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    id: z.string().min(1).max(21),
    name: z.string().min(1).max(128),
    description: z.string().max(256).nullable(),
    type: z.nativeEnum(RoleType),
});
export const OrganizationRoles = Object.freeze({
    table: 'organization_roles',
    tableSingular: 'organization_role',
    fields: {
        tenantId: 'tenant_id',
        id: 'id',
        name: 'name',
        description: 'description',
        type: 'type',
    },
    fieldKeys: [
        'tenantId',
        'id',
        'name',
        'description',
        'type',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
